import {
  formatKgPerHourValue,
  createKpiTileItem,
} from '../../../../utils/helper';
import { KpiHandler, IPCSummaryData } from './types';
import { KpiData } from 'components/redesign/KpiTile/types';

const wasteReduced: KpiHandler = {
  type: 'KpiTile',
  handler: (data: IPCSummaryData): KpiData => {
    const { wasteReduced } = data;

    const formattedValue = formatKgPerHourValue(wasteReduced);

    return createKpiTileItem('Waste Reduced', formattedValue, []);
  },
};

export default wasteReduced;
